<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Withdrawal Payout Fields</h4>
        <div class="text-muted small">Manage dynamic destination fields for withdrawal forms</div>
      </div>

      <button class="btn btn-primary btn-sm" type="button" (click)="openCreateModal()">
        Add Field
      </button>
    </div>

    <div class="card shadow-sm border-0 mb-3">
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label">Jurisdiction</label>

            <select class="form-select" [(ngModel)]="filterJurisdictionCode" [ngModelOptions]="{standalone: true}">
              <option value="">Select country</option>
              <option *ngFor="let country of countries" [value]="country.code">
                {{ country.name }} ({{ country.code }})
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label">Payment Method</label>
            <select class="form-select" [(ngModel)]="filterPaymentMethod" [ngModelOptions]="{standalone: true}">
              <option value="">All</option>
              <option *ngFor="let item of paymentMethodOptions" [value]="item">{{ item }}</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label">Gateway Config</label>
            <select class="form-select" [(ngModel)]="filterGatewayConfigId" [ngModelOptions]="{standalone: true}">
              <option value="">All</option>
              <option *ngFor="let cfg of configs" [value]="cfg.id">
                {{ cfg.providerName }} - {{ cfg.name }}
              </option>
            </select>
          </div>

          <div class="col-12">
            <button class="btn btn-outline-secondary" type="button" (click)="loadFields()">
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm me-2"></div>
          Loading payout fields...
        </div>

        <div class="table-responsive" *ngIf="!loading">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Jurisdiction</th>
                <th>Gateway</th>
                <th>Method</th>
                <th>Field Key</th>
                <th>Label</th>
                <th>Type</th>
                <th>Required</th>
                <th>Sort</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of filteredFields">
                <td class="fw-semibold">{{ item.jurisdictionCode }}</td>
                <td>{{ getConfigName(item.paymentGatewayConfigId) }}</td>
                <td>{{ item.paymentMethod || '-' }}</td>
                <td><code>{{ item.fieldKey }}</code></td>
                <td>{{ item.label }}</td>
                <td>{{ item.fieldType }}</td>
                <td>{{ item.isRequired ? 'Yes' : 'No' }}</td>
                <td>{{ item.sortOrder }}</td>
                <td>
                  <span class="badge rounded-pill" [ngClass]="badgeClass(item.isActive)">
                    {{ item.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td class="text-end">
                  <div class="d-flex gap-2 justify-content-end">
                    <button class="btn btn-outline-primary btn-sm" type="button" (click)="openEditModal(item)">
                      Edit
                    </button>

                    <button class="btn btn-outline-danger btn-sm" type="button" (click)="deleteField(item)">
                      Delete
                    </button>

                    <button class="btn btn-outline-warning btn-sm" type="button" (click)="toggleStatus(item)">
                      {{ item.isActive ? 'Disable' : 'Enable' }}
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="!filteredFields.length">
                <td colspan="10" class="text-center text-muted py-4">
                  No payout fields found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </main>
</div>
<div class="modal fade show" tabindex="-1" [ngStyle]="{ display: showModal ? 'block' : 'none' }"
  [class.d-block]="showModal" *ngIf="showModal">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ editingId ? 'Edit Withdrawal Payout Field' : 'Create Withdrawal Payout Field' }}
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>

      <form [formGroup]="form" (ngSubmit)="save()" novalidate>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label fw-semibold">Quick Templates</label>

            <div class="d-flex flex-wrap gap-2">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="insertNgBankSelectTemplate()">
                NG Bank Select
              </button>

              <button type="button" class="btn btn-outline-primary btn-sm" (click)="insertStaticSelectTemplate()">
                Static Select
              </button>

              <button type="button" class="btn btn-outline-primary btn-sm"
                (click)="insertAccountNumberValidationTemplate()">
                Account Number Rules
              </button>

              <button type="button" class="btn btn-outline-primary btn-sm"
                (click)="insertResolvedAccountNameTemplate()">
                Resolved Account Name
              </button>

              <button type="button" class="btn btn-outline-primary btn-sm" (click)="insertEmailValidationTemplate()">
                Email Validation
              </button>
            </div>
          </div>

          <div class="alert alert-light border mb-3" *ngIf="!editingId">
            <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
              <div>
                <div class="fw-semibold">Field Templates</div>
                <div class="small text-muted">
                  Prefill fields for CAD Interac, USD ACH, GBP bank transfer, and EUR bank transfer.
                </div>
              </div>

              <button class="btn btn-sm btn-outline-secondary" type="button" *ngIf="selectedBlaaizTemplateCurrency"
                (click)="nextBlaaizTemplateField()">
                Next Field
              </button>
            </div>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn btn-sm btn-outline-primary" type="button" (click)="applyBlaaizFieldTemplate('CAD')">
                CAD Interac
              </button>

              <button class="btn btn-sm btn-outline-primary" type="button" (click)="applyBlaaizFieldTemplate('USD')">
                USD ACH
              </button>

              <button class="btn btn-sm btn-outline-primary" type="button" (click)="applyBlaaizFieldTemplate('GBP')">
                GBP Bank
              </button>

              <button class="btn btn-sm btn-outline-primary" type="button" (click)="applyBlaaizFieldTemplate('EUR')">
                EUR Bank
              </button>
            </div>

            <div class="small text-muted mt-2" *ngIf="selectedBlaaizTemplateCurrency">
              Current template:
              <strong>{{ selectedBlaaizTemplateCurrency }}</strong>
              — Field {{ currentBlaaizTemplateFieldNumber }}
              of {{ getCurrentBlaaizTemplateFields().length }}
            </div>
          </div>

          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Jurisdiction</label>
              <select class="form-select" formControlName="jurisdictionCode">
                <option value="">Select country</option>
                <option *ngFor="let country of countries" [value]="country.code">
                  {{ country.name }} ({{ country.code }})
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Gateway Config</label>
              <select class="form-select" formControlName="paymentGatewayConfigId">
                <option value="">All Gateways</option>
                <option *ngFor="let cfg of configs" [value]="cfg.id">
                  {{ cfg.providerName }} - {{ cfg.name }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Payment Method</label>
              <select class="form-select" formControlName="paymentMethod">
                <option value="">All Methods</option>
                <option *ngFor="let item of paymentMethodOptions" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Field Key</label>
              <input type="text" class="form-control" formControlName="fieldKey" placeholder="accountNumber" />
            </div>

            <div class="col-md-4">
              <label class="form-label">Label</label>
              <input type="text" class="form-control" formControlName="label" placeholder="Account Number" />
            </div>

            <div class="col-md-4">
              <label class="form-label">Field Type</label>
              <select class="form-select" formControlName="fieldType">
                <option *ngFor="let item of fieldTypeOptions" [value]="item">{{ item }}</option>
              </select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Sort Order</label>
              <input type="number" class="form-control" formControlName="sortOrder" />
            </div>

            <div class="col-md-9">
              <label class="form-label">Placeholder</label>
              <input type="text" class="form-control" formControlName="placeholder"
                placeholder="Enter account number" />
            </div>

            <div class="col-md-12">
              <label class="form-label">Help Text</label>
              <input type="text" class="form-control" formControlName="helpText"
                placeholder="Used for payout destination" />
            </div>

            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center">
                <label class="form-label mb-0">Options JSON</label>
                <button type="button" class="btn btn-link btn-sm p-0" (click)="formatOptionsJson()">
                  Format JSON
                </button>
              </div>
              <textarea class="form-control font-monospace" rows="6" formControlName="optionsJson" placeholder='{
  "type": "lookup",
  "lookupType": "institution",
  "filters": {
    "countryCode": "NG",
    "providerCode": "FLUTTERWAVE"
  },
  "valueField": "value",
  "labelField": "label"
}'></textarea>
            </div>

            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center">
                <label class="form-label mb-0">Validation JSON</label>
                <button type="button" class="btn btn-link btn-sm p-0" (click)="formatValidationJson()">
                  Format JSON
                </button>
              </div>
              <textarea class="form-control font-monospace" rows="5" formControlName="validationJson" placeholder='{
  "minLength": 10,
  "maxLength": 10,
  "pattern": "^[0-9]+$",
  "message": "Account number must be 10 digits"
}'></textarea>
            </div>

            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center">
                <label class="form-label mb-0">Metadata JSON</label>
                <button type="button" class="btn btn-link btn-sm p-0" (click)="formatMetadataJson()">
                  Format JSON
                </button>
              </div>
              <textarea class="form-control font-monospace" rows="5" formControlName="metadataJson" placeholder='{
  "readonly": true,
  "resolved": true
}'></textarea>
            </div>

            <div class="col-md-3">
              <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" formControlName="isRequired" id="isRequired">
                <label class="form-check-label" for="isRequired">
                  Required
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-outline-secondary" type="button" (click)="closeModal()">
            Cancel
          </button>
          <button class="btn btn-primary" type="submit" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
            {{ editingId ? 'Update Field' : 'Save Field' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showModal"></div>
